import { EventBundlePublishingState } from '../../enums';
import { IsArray, IsBoolean, IsEnum, IsNotEmpty, IsNumber, IsString, IsUUID, Min } from 'class-validator';
import { EventDto } from './event.dto';
import { UserDto } from './user.dto';
import { UserToEventBundleDto } from './user-to-event-bundle.dto';

export class EventBundleAdditionalDataDto {
	allowKlarnaPayments?: boolean;
}

export class UpsertEventBundleDto {
	@IsString()
	@IsNotEmpty({ message: 'Name is required' })
	name: string;

	@IsNumber()
	@IsNotEmpty({ message: 'Visits amount is required' })
	@Min(1, { message: 'Visits amount must be greater than 0' })
	visitsAmount: number;

	@IsNumber()
	@IsNotEmpty({ message: 'Price is required' })
	@Min(1, { message: 'Price must be greater than 0' })
	price: number;

	@IsString()
	@IsNotEmpty({ message: 'Description is required' })
	description: string;

	@IsBoolean()
	@IsNotEmpty()
	includeAllEvents: boolean;

	@IsEnum(EventBundlePublishingState)
	@IsNotEmpty()
	publishingState: EventBundlePublishingState;

	@IsNumber()
	@Min(1, { message: 'Validity period must be greater than 0' })
	@IsNotEmpty({ message: 'Validity period is required' })
	validityPeriodInDays: number;

	additionalData?: EventBundleAdditionalDataDto;

	@IsArray()
	@IsUUID(undefined, { each: true })
	applicableEvents?: string[];

	communityId?: string;

	public static fromEventBundle(eventBundle: EventBundleDto): UpsertEventBundleDto {
		const allEventsIds = eventBundle.events?.map(event => event.baseId) ?? [];
		const applicableEvents = [...new Set(allEventsIds)];

		const {
			publishingState,
			communityId,
			name,
			description,
			visitsAmount,
			price,
			validityPeriodInDays,
			includeAllEvents,
			additionalData,
		} = eventBundle;

		const data: UpsertEventBundleDto = {
			includeAllEvents,
			publishingState,
			communityId,
			name,
			description,
			visitsAmount,
			price,
			validityPeriodInDays,
			applicableEvents,
			additionalData,
		}

		return data;
	}
}

export class EventBundleDto extends UpsertEventBundleDto {
	id: string;
	createdAt: Date;
	updatedAt: Date;
	deletedAt?: Date;

	community?: UserDto;
	events?: EventDto[];
	members?: UserToEventBundleDto[];
}

export class EventBundleStatsDto {
	purchasesAmount: number;
	totalRevenue: number;
	thisWeekRevenue: number;
}

export class EventBundleWithStatsDto extends EventBundleDto {
  purchasesAmount?: number;
  totalRevenue?: number;
  thisWeekRevenue?: number;
}
